// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3dTws","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__AqErj"};